import tuvSrc from '@/assets/images/certificates/tuv.jpg';
import tlsSrc from '@/components/logos/assets/tls.png';
import { useAppSelector } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';
import cn from '@/components/logos/logos.module.css';

const Logos = () => {
  const certificateLogos = useAppSelector(ConfigSlice.selectors.certificateLogos);

  return (
    <div className={cn.Logos}>
      {certificateLogos.map((certificateLogo) => {
        switch (certificateLogo) {
          case 'tuv':
            return <img key={certificateLogo} data-testid='tuv' alt='tuv-icon' src={tuvSrc} className={cn.Tuv} />;
          case 'tls':
            return (
              <div key={certificateLogo} data-testid='tls' className={cn.Tls}>
                <img alt='tls-icon' src={tlsSrc} className={cn.Icon} />
                <div>
                  <div className={cn.Text}>Höchste</div>
                  <div className={cn.Text}>Datensicherheit.</div>
                </div>
              </div>
            );
        }
      })}
    </div>
  );
};

export default Logos;
